import { useEffect, useRef, useState, useParams } from '../../common/common';
import { useErrorContext } from '../../context/ErrorContext';
import axiosJWT from '../../secureAPI/axiosJWT';
import useGetUserData from '../../secureAPI/GetUserData';
import Navigations from '../../common/useNavigation.js';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils.js';
import { showToast } from '../../Utils/toastUtils.js';
import { useReactToPrint } from "react-to-print";
const MidViewOrdersDetails = (type) => {
   
    const params = useParams();
    const order_row_id = params.id;
    const { navigateDashboard } = Navigations();
    const { users } = useGetUserData();
    const [isDisabled, setisDisabled] = useState(false);
    const [isLoading, setisLoading] = useState(false);


    const [invoiceBuyerDetails, setInvoiceBuyerDetails] = useState([]);
    const [invoiceSellerDetails, setInvoiceSellerDetails] = useState([]);
    const [invoiceDetails, setInvoiceDetails] = useState([]);
    const [orderDetails, setOrderDetails] = useState([]);
    
    const [totalAmout, setTotalAmout] = useState([]);
    const componentPDF = useRef();
    const generatePDF = useReactToPrint({
        content: () => componentPDF.current,
        documentTitle: "UserData",
        onAfterPrint: () => window.location.reload(),
    });
    useEffect(() => {
          if (Array.isArray(users) && users.length > 0) {
              logUserData(); 
          }
      }, [users]); 
      
        const logUserData = () => {
            // console.log({users:users});
          if (users?.length > 0) {
            const userTypes = users[0]['UserType'];
            const usertypeArray = typeof userTypes === 'string' ? userTypes.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num)) : [];
    
            const hasOne = usertypeArray.includes(1);
            const hasTwo = usertypeArray.includes(2);
            if (type === 'buyer' && users[0]['IsPersonalDetils'] === 1 && hasOne ) {
            }
            else if (type === 'seller' && users[0]['IsPersonalDetils'] === 1 && (hasOne && hasTwo) ) {
                
            }
            else
            {
                if (type === 'buyer' )
                {
                    navigateDashboard('buyer');
                }
                else  if (type === 'seller' )
                {
                    navigateDashboard('seller');
                }
            }

          }
        };
    useEffect(() => {
        getorderDetails();
    }, []);
    const getorderDetails = async () => {
        StartLoading(setisLoading);
        // console.log('order_row_id' + order_row_id);
        if (order_row_id !== '') {
            try {
                await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/GetOrderDetails`, {orderId: order_row_id,userType: type,app:0},{ withCredentials: true})
                    .then((res) => {
                        StopLoading(setisLoading);
                        if (res.data.success === 1) {

                            // console.log(res.data);
                            // const ordersTemp = res.data.data;
                            // setOrderDetails(res.data.data);

                            setInvoiceBuyerDetails(res.data.OrdersBuyerDetails);
                            setInvoiceSellerDetails(res.data.OrdersSellerDetails);
                            setInvoiceDetails(res.data.OrdersInvoiceDetails[0]);
                            setOrderDetails(res.data.orderDetails);
                            
                            // setInvoiceDetails({...invoiceDetails,
                            //     sellerGSTState: res.data.sellerGSTstate || null,

                            //     order_full_name: res.data.data[0]['full_name'] || null,
                            //     order_invoice_number: res.data.data[0]['order_unique_key'] || null,
                            //     order_address: res.data.data[0]['address'] || null,
                            //     order_date: res.data.data[0]['order_created_date'] || null,
                            //     order_contact_number: res.data.data[0]['mobile'] || null,
                            //     seller_email: res.data.data[0]['email'] || null,
                            //     seller_website: res.data.data[0]['company_website'] || null,
                            //     order_shipping_address: res.data.data[0]['address'] || null,
                            //     order_shipping_address_title: res.data.data[0]['address_title'] || null,
                            //     company_name: res.data.userDetails[0]['company_name'] || null,
                            //     GSTNumber: res.data.userDetails[0]['company_gst_number'] || null,
                            //     address1: res.data.userDetails[0]['address1'] || null,
                            //     address2: res.data.userDetails[0]['address2'] || null,
                            //     cityName: res.data.userDetails[0]['cityName'] || null,
                            //     stateName: res.data.userDetails[0]['stateName'] || null,
                            //     countryName: res.data.userDetails[0]['countryName'] || null,
                            //     pincode: res.data.userDetails[0]['pincode'] || null,
                            //     sellerGSTState: res.data.sellerGSTstate || null,
                            //     BuyerGSTState: res.data.BuyerGSTstate || null,
                            //     invoiceNumber: res.data.orderDetails[0]['order_unique_key'] || null,
                            //     orderCreatedDate: res.data.orderDetails[0]['order_created_date'] || null,
                            //     BuyerCompanyName: res.data.OrdersBuyerDetails[0]['company_name'] || null,
                            //     BuyerGSTNumber: res.data.OrdersBuyerDetails[0]['company_gst_number'] || null,
                            //     BuyerAddress1: res.data.OrdersBuyerDetails[0]['address1'] || null,
                            //     BuyerAddress2: res.data.OrdersBuyerDetails[0]['address2'] || null,
                            //     Buyercity: res.data.OrdersBuyerDetails[0]['cityName'] || null,
                            //     BuyerState: res.data.OrdersBuyerDetails[0]['stateName'] || null,
                            //     BuyerCountry: res.data.OrdersBuyerDetails[0]['countryName'] || null,
                            //     BuyerPincode: res.data.OrdersBuyerDetails[0]['pincode'] || null,
                            //     BuyerName: res.data.OrdersBuyerDetails[0]['full_name'] || null,
                            //     BuyerContact1: res.data.OrdersBuyerDetails[0]['mobile'] || null,
                            //     BuyerContact2: res.data.OrdersBuyerDetails[0]['contact_number'] || null,
                            //     BuyerEmail: res.data.OrdersBuyerDetails[0]['email'] || null,
                            // });
                            // const totalAmount = ordersTemp.reduce((acc, order) => {
                            //     return acc + order.product_price * order.shipping_unit * order.quantity;
                            //   }, 0);
                            //   setTotalAmout(totalAmount);
                        }
                        else {
                            StopLoading(setisLoading)
                            showToast(res.data.message, 'error');
                        }
                    })
                    .catch((err) => {
                        StopLoading(setisLoading)
                        showToast('Something went wrong ! please try again ', 'error');
                    });

            } catch (err) {
                StopLoading(setisLoading);
                showToast("Failed to get Order Details, please try again later ", 'error');
            }
        }
        else {
            StopLoading(setisLoading);
            showToast('please enter supplier id first ', 'error');
        }
    }
    return { users, generatePDF, invoiceDetails, componentPDF,orderDetails,totalAmout,invoiceBuyerDetails,invoiceSellerDetails }
}
export default MidViewOrdersDetails